const scopes = [
  'user-read-private',
  'user-read-email',
  'playlist-read-collaborative',
  'playlist-read-private',
  'playlist-modify-private',
  'playlist-modify-public',
  'user-top-read',
];

export default scopes;
